import type {
    fetchStepRequest,
    fetchStepResponse,
    RegenerateIdeaRequest,
    IdeaSolutionRequest,
    GenerateExtendIdeaRequest,
    FetchVideoResultRequest,
    ExportPptRequest,
    ExportPptPreviewRequest,
    ExportPptPreviewResponse,
    SolutionNoveltyAnalysisRes,
    SolutionValidationAnalysisRes,
    VideoSubmitRequest,
    VideoResultResponse,
    ImageSubmitRequest,
    ImageResultResponse,
} from '../types';

export const TrizApi = Symbol('TrizApi');

export interface TrizApi {
    fetchStepsData(data: fetchStepRequest): Promise<fetchStepResponse>;
    regenerateIdea(data: RegenerateIdeaRequest): Promise<any>;
    fetchIdeaSolutionValidate(data: IdeaSolutionRequest): Promise<SolutionValidationAnalysisRes>;
    fetchIdeaSolutionNovelty(data: IdeaSolutionRequest): Promise<SolutionNoveltyAnalysisRes>;
    generateExtendIdea(data: GenerateExtendIdeaRequest): Promise<any>;
    submitVideo(data: VideoSubmitRequest): Promise<any>;
    fetchVideoResult(data: FetchVideoResultRequest): Promise<VideoResultResponse>;
    submitImage(data: ImageSubmitRequest): Promise<any>;
    fetchImageResult(data: { triz_mind_id: string; idea_id: string }): Promise<ImageResultResponse>;
    exportPpt(data: ExportPptRequest): Promise<any>;
    fetchExportPptPreview(data: ExportPptPreviewRequest): Promise<ExportPptPreviewResponse>;
}
